<template>
    <div>
        <!-- 翻页动画容器 -->
        <div ref="flipbookContainer" class="flipbook">
            <!-- 动态生成页面，内容为预渲染的图片 -->
            <div class="page" v-for="(imgSrc, index) in pageImages" :key="index">
                <img :src="imgSrc" :alt="`Page ${index + 1}`" style="width:100%; height:100%; object-fit: contain;" />
            </div>
        </div>

        <!-- Ant Design Vue 控制栏 -->
        <a-space class="controls">
            <a-button @click="flipPrev" :disabled="currentPage <= 1">
                <template #icon><LeftOutlined /></template>上一页
            </a-button>
            <span> {{ currentPage }} / {{ totalPages }} </span>
            <a-button @click="flipNext" :disabled="currentPage >= totalPages">
                下一页<template #icon><RightOutlined /></template>
            </a-button>
            <a-slider
                    v-model:value="currentPage"
                    :min="1"
                    :max="totalPages"
                    style="width: 120px;"
                    @change="jumpToPage"
            />
        </a-space>
    </div>
</template>

<script setup>
    import { ref, onMounted } from 'vue';
    import * as PDFJS from 'pdfjs-dist';
    import St from 'page-flip';
    import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue';
    const currentPage = ref(1);

    // 控制方法
    const flipPrev = () => {
        pageFlip?.flipPrev();
        // 需要监听pageFlip的翻页事件来同步更新currentPage
    };
    const flipNext = () => {
        pageFlip?.flipNext();
    };
    const jumpToPage = (pageNum) => {
        // page-flip.js 可能需要通过多次调用 flipNext/flipPrev 来实现跳转
        // 或者寻找其他支持直接跳转的动画库
        console.log(pageNum);
    };
    const flipbookContainer = ref(null);
    let pageFlip = null;

    const initPageFlip = () => {
        if (!flipbookContainer.value) return;
        pageFlip = new St.PageFlip(flipbookContainer.value, {
            width: 600, // 根据你的设计调整
            height: 800,
            size: 'stretch',
            maxShadowOpacity: 0.5,
        });
        // 从容器中的 .page 元素加载
        pageFlip.loadFromHTML(document.querySelectorAll('.page'));
    };



    PDFJS.GlobalWorkerOptions.workerSrc = '//cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

    const pdfDoc = ref(null);
    const totalPages = ref(0);
    const pageImages = ref([]); // 用于存储渲染好的页面图片URL

    // 加载并预渲染PDF
    const loadAndRenderPDF = async (url) => {
        const loadingTask = PDFJS.getDocument(url);
        pdfDoc.value = await loadingTask.promise;
        totalPages.value = pdfDoc.value.numPages;

        for (let i = 1; i <= totalPages.value; i++) {
            const page = await pdfDoc.value.getPage(i);
            const viewport = page.getViewport({ scale: 1.5 });
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            await page.render({ canvasContext: context, viewport: viewport }).promise;
            // 将canvas转换为图片URL
            pageImages.value.push(canvas.toDataURL('image/png'));
        }
        // 所有页面渲染完成后，初始化翻页动画
        initPageFlip();
    };

    onMounted(() => {
        loadAndRenderPDF('/test2.pdf');
    });

</script>